import React from 'react';
import { motion } from 'framer-motion';
import { CountdownBanner } from './CountdownBanner';
export function Nav() {
  return <motion.nav initial={{
    y: -100
  }} animate={{
    y: 0
  }} transition={{
    duration: 0.5
  }} className="fixed top-0 left-0 right-0 z-50 shadow-sm" data-id="element-163">
      <CountdownBanner data-id="element-164" />
    </motion.nav>;
}